import { MarketLayoutStylesSchema } from './MarketLayout.styles';

export const matchDetailsStyles: MarketLayoutStylesSchema = {
  headerText: {
    flex: '1',
    align: 'center',
    fontSize: '2xs',
    fontWeight: 'bold',
    color: 'gray.700',
  },

  rowWrapper: {
    px: '4',
    py: '2',
    alignItems: 'center',
    display: 'flex',
    fontWeight: 'bold',
    justifyContent: 'space-between',
    borderColor: 'transparent',
    borderTopWidth: undefined,
    gap: '2',
    pos: 'relative',
    color: 'gray.700',
    fontSize: 'xs',
    _after: {
      borderColor: 'blackAlpha.300',
      borderBottomWidth: '1px',
      boxShadow: '0 1px rgba(255, 255, 255, .07)',
      content: '""',
      w: 'full',
      left: '0',
      pos: 'absolute',
      bottom: '0px',
    },
  },
  rowWrapperFirst: {
    borderTopWidth: '1px',
    color: 'gray.700',
    fontWeight: 'bold',
    fontSize: 'xs',
  },
  rowWrapperWithBtn: {
    bg: 'white',
  },

  tab: {
    bg: 'alpha.400',
    borderBottom: '1px',
    borderColor: 'white',
    color: 'white',
    fontSize: '2xs',
    fontWeight: 'bold',
    _notFirst: { borderLeftWidth: '1px' },
    _selected: {
      bg: 'alpha.700',
      borderBottomColor: 'transparent',
      color: 'white',
    },
  },
};
